module.exports = __webpack_public_path__ + "static/xmasonesie-863a53cb32239b5d7d8883d38420c5ff.jpeg";